/*
 * Brazilian phone number validator
 * Validates Brazilian phone numbers with DDD and subscriber number
 */

const VALID_DDDS = [
    11, 12, 13, 14, 15, 16, 17, 18, 19,
    21, 22, 24,
    27, 28,
    31, 32, 33, 34, 35, 37, 38,
    41, 42, 43, 44, 45, 46,
    47, 48, 49,
    51, 53, 54, 55,
    61,
    62, 64,
    63,
    65, 66,
    67,
    68,
    69,
    71, 73, 74, 75, 77,
    79,
    81, 87,
    82,
    83,
    84,
    85, 88,
    86, 89,
    91, 93, 94,
    92, 97,
    95,
    96,
    98, 99,
];

function isValidBrazilianPhone(value) {
    const digits = String(value).replace(/\D/g, '');

    if (digits.length !== 10 && digits.length !== 11) {
        return false;
    }

    const ddd = parseInt(digits.substring(0, 2), 10);

    if (!VALID_DDDS.includes(ddd)) {
        return false;
    }

    const subscriber = digits.substring(2);

    if (/^(\d)\1+$/.test(subscriber)) {
        return false;
    }

    if (digits.length === 11) {
        // Mobile phone in Brazil: DDD + 9 + 8 digits
        return /^[1-9]{2}9\d{8}$/.test(digits);
    }

    // Fixed phone in Brazil: DDD + [2-5] + 7 digits
    return /^[1-9]{2}[2-5]\d{7}$/.test(digits);
}

$.validator.addMethod(
    'brazilianPhone',
    function (value, element) {
        'use strict';

        if (this.optional(element)) {
            return true;
        }

        return isValidBrazilianPhone(value);
    },
    'O telefone informado é inválido. Verifique o DDD e o número.'
);
